/**
 * This is the JS file for anonymous tracking functions
 */

/*jshint -W069 */

//Segment Emitter
analytics.on('identify', function(userId, traits, options){
	var dateString = new Date(Date.now()).toISOString();

	appendInLocalStorageMention('mention_anonymous_tracking',
		['action', 'anonymousId', 'userId', 'traits', 'context', 'timestamp', 'integrations'],
		['identify', null, null, traits, (options === undefined) ? null : options['context'], dateString, {'all':false, 'Customer.io':true, 'Amplitude':true}]
	);

	checkBeforeSendSegmentDate();
});

analytics.on('track', function(event, properties, options){
	var dateString = new Date(Date.now()).toISOString();

	appendInLocalStorageMention('mention_anonymous_tracking',
		['action', 'anonymousId', 'userId', 'event', 'properties', 'context', 'timestamp', 'integrations'],
		['track', null, null, event, properties, (options === undefined) ? null : options['context'], dateString, {'all':false, 'Customer.io':true}]
	);

	checkBeforeSendSegmentDate();
});

analytics.on('page', function(category, name, properties, options){
	var dateString = new Date(Date.now()).toISOString();

	appendInLocalStorageMention('mention_anonymous_tracking',
		['action', 'anonymousId', 'userId', 'name', 'properties', 'context', 'timestamp', 'integrations'],
		['page', null, null, name, properties, (options === undefined) ? null : options['context'], dateString, {'all':false, 'Customer.io':true}]
	);

	checkBeforeSendSegmentDate();
});

analytics.on('alias', function(userId, previousId, options){
	var dateString = new Date(Date.now()).toISOString();

	appendInLocalStorageMention('mention_anonymous_tracking',
		['action', 'previousId', 'userId', 'context', 'timestamp', 'integrations'],
		['alias', previousId, userId, (options === undefined) ? null : options['context'], dateString, {'all':false, 'Customer.io':true, 'Amplitude':true}]
	);

	checkBeforeSendSegmentDate();
});

analytics.on('group', function(groupId, traits, options){
	var dateString = new Date(Date.now()).toISOString();

	appendInLocalStorageMention('mention_anonymous_tracking',
		['action', 'anonymousId', 'userId', 'groupId', 'traits', 'context', 'timestamp', 'integrations'],
		['group', null, null, groupId, traits, (options === undefined) ? null : options['context'], dateString, {'all':false, 'Customer.io':true, 'Amplitude':true}]
	);

	checkBeforeSendSegmentDate();
});

// Add in local storage event
function appendInLocalStorageMention(nameLocalStorage, nameDataLocalArray, valueDataLocalArray) {

			var dataLocal = {};
			for (var i = 0; i < nameDataLocalArray.length; i++) {
				dataLocal[nameDataLocalArray[i]] = valueDataLocalArray[i];
			}

			var arrayLocal = localStorage.getItem(nameLocalStorage);
			arrayLocal = (arrayLocal === null) ? [] : JSON.parse(arrayLocal);
			arrayLocal.push(dataLocal);
			localStorage.setItem(nameLocalStorage, JSON.stringify(arrayLocal));
}

// check segmentID
var anonymousIdStorage = null;
var segmentIdStorage = null;

analytics.ready(function() {
	anonymousIdStorage = analytics.user().anonymousId();
	segmentIdStorage = analytics.user().id();
	checkBeforeSendSegmentDate();
});

function checkBeforeSendSegmentDate() {
	if (segmentIdStorage !== null && segmentIdStorage.match('^([0-9])+_'))
	{
		//Send Data to Segment
		var dataBatch = {};
		dataBatch['batch'] = JSON.parse(localStorage.getItem('mention_anonymous_tracking'));
		//Replace userId to segmentIdLocal in json localsotrage
		if(dataBatch['batch'] !== null) {
			dataBatch['batch'].forEach(function(value, index, array){
				value['userId'] = segmentIdStorage;
				value['anonymousId'] = anonymousIdStorage;
			});
			sendDataToSegment('https://api.segment.io/v1/import', JSON.stringify(dataBatch));
			//Clean all data sended
			localStorage.removeItem('mention_anonymous_tracking');
		}
	}
}

function sendDataToSegment(endpoint, data) {
	$.ajax({
		async: false, // When singup step, the sending data have no time to finish before the connection.
		url: endpoint,
		type: 'POST',
		data: data,
	  headers: {
	    "Authorization": "Basic " + btoa("dmwrDWMOsBvQc9az5rnrq1EZR3rRUN7U" + ":" + ''),
			"Content-Type": "application/json"
	  },
		success: function(dataResponse) {
			console.log('Success Send Data To Segment');
		},
		error: function(xhr, status, error) {
			console.log('Error Send Data To Segment');
		}
	});
}
